export default __webpack_public_path__ + "static/media/Rabia_Subhani_AHV_In_Moms_We_Trust.80566aa8.jpg";